import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { RefConstants } from '../../../helpers/Constants';
import { IReferential } from '../../../interfaces/IReferential';
import moment from 'moment';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import NumberFormat from 'react-number-format';
import { IVehicleService } from '../../../services/Interfaces/IVehicleService';
import { AlcorParameterInfo } from '../../../interfaces/Vehicle';

interface IAlcorParameterInfoListState {
  newAlcorParameterInfo: AlcorParameterInfo;
  alcorParameters: IReferential[];
  alcorParametersInfoList: AlcorParameterInfo[];
  isLoading: boolean;
  isDialogOpen: boolean;
  newAlcorParameterInfoId: number | null;
}

type IAlcorParameterInfoListProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;

class AlcorParameterInfoList extends React.PureComponent<
  IAlcorParameterInfoListProps,
  IAlcorParameterInfoListState
> {
  private translatorService!: ITranslatorService;
  private vehicleService!: IVehicleService;
  private appReferentialService!: IReferentialService;

  static contextType = ApplicationContext;
  private newAlcorParameterInfo = {
    id: 0,
    value: '',
    alcorParameterId: null,
    alcorParameter: null
  } as unknown as AlcorParameterInfo;

  state = {
    alcorParameters: [],
    isLoading: false,
    selectedFilter: 0,
    isDialogOpen: false,
    newAlcorParameterInfo: this.newAlcorParameterInfo,
    alcorParametersInfoList: [],
    newAlcorParameterInfoId: null
  } as IAlcorParameterInfoListState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadAlcorParameterInfoList();
      }
    );
  }

  loadAlcorParameterInfoList = async () => {
    const alcorParametersInfoList = await this.vehicleService.GetAlcorParameterInfoList();
    const { alcorParameterRef } = RefConstants;

    const alcorParameters = await this.appReferentialService.Get(alcorParameterRef!.baseUrl);

    this.setState({
      alcorParameters: alcorParameters,
      isLoading: false,
      alcorParametersInfoList: alcorParametersInfoList,
      newAlcorParameterInfo: { ...this.newAlcorParameterInfo }
    });
  };

  private handleAlcorParameterChange = (newValue: IReferential | null) => {
    this.setState({
      newAlcorParameterInfo: {
        ...this.state.newAlcorParameterInfo,
        alcorParameter: newValue,
        alcorParameterId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  public saveAlcorParameterInfo = async () => {
    if (this.state.newAlcorParameterInfoId === null) {
      try {
        await this.vehicleService.AddAlcorParameterInfo(this.state.newAlcorParameterInfo);

        await this.loadAlcorParameterInfoList();

        this.closeDialog();

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    } else {
      try {
        await this.vehicleService.UpdateAlcorParameterInfo(this.state.newAlcorParameterInfo);

        await this.loadAlcorParameterInfoList();

        this.closeDialog();

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  NumberFormatCustom = (props: any) => {
    const { inputRef, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value
            },
            currentTarget: {
              value: values.value
            }
          });
        }}
        allowNegative={false}
        thousandSeparator={false}
        decimalScale={0}
      />
    );
  };

  onChange = (fieldName: string, isNumber: boolean) => (e: any, newValue?: IReferential | null) => {
    isNumber
      ? this.setState({
          newAlcorParameterInfo: {
            ...this.state.newAlcorParameterInfo,
            [fieldName]: parseFloat(newValue || e.target.value)
          }
        })
      : this.setState({
          newAlcorParameterInfo: {
            ...this.state.newAlcorParameterInfo,
            [fieldName]: newValue || e.target.value
          }
        });
  };

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.saveAlcorParameterInfo} instantValidate={true}>
        <Box mb={2}>
          <Autocomplete
            id="alcorParameter"
            fullWidth
            options={this.state.alcorParameters}
            value={this.state.newAlcorParameterInfo.alcorParameter}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handleAlcorParameterChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="alcorParameter"
                value={this.state.newAlcorParameterInfo.alcorParameter}
                label={this.translatorService.Tranlate('ALCOR_PARAMETER', 'Parametru alcor')}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                ]}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            id="value"
            name="value"
            placeholder={this.translatorService.Tranlate('FINANCIAL_PARAMETER_INFO_VALUE', 'Valoare')}
            value={this.state.newAlcorParameterInfo.value}
            onChange={(e: any) => this.onChange('value', false)(e)}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
            label={this.translatorService.Tranlate('FINANCIAL_PARAMETER_INFO_VALUE', 'Valoare')}
          />
        </Box>

        <div className="text-right">
          <Button className="m-2" variant="outlined" color="default" onClick={this.closeDialog}>
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
      </ValidatorForm>
    );
  }

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'alcorParameter',
        label: this.translatorService.Tranlate('ALCOR_PARAMETER', 'Parametru Alcor'),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            return a.displayName!.localeCompare(b.displayName!);
          },
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'value',
        label: this.translatorService.Tranlate('FINANCIAL_PARAMETER_INFO_VALUE', 'Valoare'),
        options: {
          filter: false,
          customBodyRender: (value: string, tableMeta: MUIDataTableMeta) => {
            return value;
          }
        }
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          sortDirection: 'desc',
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            const alcorParameterInfo = this.state.alcorParametersInfoList.find(
              (item) => item.id === tableMeta.rowData[0]
            );

            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newAlcorParameterInfoPopup(tableMeta.rowData[0])}
                >
                  <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteAlcorParameterInfo(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }
    ];

    return columns;
  };

  deleteAlcorParameterInfo = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];

      await this.vehicleService.RemoveAlcorParameterInfo(id);

      await this.loadAlcorParameterInfoList();

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newAlcorParameterInfoPopup = async (alcorParameterInfoId: number | null) => {
    let newAlcorParameterInfo: AlcorParameterInfo;
    if (alcorParameterInfoId == null) {
      newAlcorParameterInfo = { ...this.state.newAlcorParameterInfo } as AlcorParameterInfo;
    } else {
      newAlcorParameterInfo = this.state.alcorParametersInfoList.find(
        (item) => item.id === alcorParameterInfoId
      )!;
    }
    this.setState({
      isDialogOpen: true,
      newAlcorParameterInfo: newAlcorParameterInfo,
      newAlcorParameterInfoId: alcorParameterInfoId
    });
  };

  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
      newAlcorParameterInfo: this.newAlcorParameterInfo,
      newAlcorParameterInfoId: null
    });
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.vehicleService = (this.context as AppContext).vehicleService;
    this.appReferentialService = (this.context as AppContext).referentialService;

    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      customToolbar: () => {
        return (
          <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
            <IconButton
              aria-label="add"
              color="secondary"
              className="m-2"
              onClick={(e) => this.newAlcorParameterInfoPopup(null)}
            >
              <AddCircleTwoToneIcon />
            </IconButton>
          </Tooltip>
        );
      }
    };

    return (
      <Fragment>
        <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.alcorParametersInfoList}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullScreen={false}
            fullWidth={true}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography className="MuiTypography-h4">
                    {!this.state.newAlcorParameterInfoId
                      ? this.translatorService.Tranlate(
                          'ALCOR_PARAMETER_INFO_NEW_MODAL_TITLE',
                          'Adauga parametru alcor'
                        )
                      : this.translatorService.Tranlate(
                          'ALCOR_PARAMETER_INFO_UPDATE_MODAL_TITLE',
                          'Actualizeaza parametru alcor'
                        )}
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>
        ) : (
          ''
        )}
      </Fragment>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(AlcorParameterInfoList as any));
